import { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import videoIsLandscape from '../utils/checkVideoOrientation';
import isMediaVideo from '../utils/checkMediaType';
import '../scss/MediaSlider.scss';

function MediaSlider({ media, thumbnails, step }) {

  const [curr, setCurr] = useState(0)
  const [isVideo, setIsVideo] = useState(false)
  const [isLandscape, setIsLandscape] = useState(false)
  const [hasThumb, setHasThumb] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)
  const [hasStarted, setHasStarted] = useState(false)
  const [hasEnded, setHasEnded] = useState(false)

  // update curr with selected <Instruction> step
  useEffect(() => {
    // handles when there is no associated step
    // and when there are more steps than images
    if (step != null && step < media.length) { 
      setCurr(step) 
    }
  }, [step])

  // update isVideo, isLandscape, and hasThumb when curr changes
  useEffect(() => {
    setIsVideo(isMediaVideo(media[curr]))
    setIsLandscape(videoIsLandscape(media[curr]))
    const currFileBase = media[curr].split('.')[0];
    setHasThumb(thumbnails?.[currFileBase] ? thumbnails[currFileBase] : false)
    setHasEnded(false)
  }, [curr])

  function prev() {
    if (curr > 0) {
      setIsPlaying(false)
      setCurr(curr - 1)
    }
  }

  function next() {
    if (curr < media.length -1) {
      setIsPlaying(false)
      setCurr(curr + 1)
    }
  }

  function play() {
    setIsPlaying(true)
    setHasStarted(true)
  }

  const pause = () => setIsPlaying(false)

  function replay() {
    setIsPlaying(true)
    setHasEnded(false)
  }

  function handleVideoEnd() {
    setHasEnded(true);
    setIsPlaying(false);
  }

  const VideoControls = () => (
    isPlaying
      ? <div className="pause-button" onClick={pause}></div>
      : hasEnded 
        ? <div className="replayButton" onClick={replay}></div>
        : <div className="play-button" onClick={play}></div>
  );

  return (
    <div className="media-slider" data-thumb={hasThumb ? true : false}>
      <div className="aspectRatioBox">
        {media.length > 1 &&
          <div className="progress-indicator">
            {media.map((m, index) => 
              <div 
                data-index={index} 
                className={index === curr ? 'active' : 'inactive'}
                style={{width: `calc(100% / ${media.length})` }}
                key={index}>
              </div>
            )}
          </div>
        }
        <div className="media-controls-overlay" data-video={isVideo}>
        {media.length > 1 && <div className="prev-button" onClick={prev}></div>}
          { isVideo && <VideoControls />}
          {media.length > 1 && <div className="next-button" onClick={next}></div>}
        </div>
        {hasThumb && !hasStarted ? <img className="thumbnail" src={hasThumb} /> : null}
        <div className="mediaItem" data-landscape={isLandscape} data-playing={isPlaying}>
          { isVideo
            ? 
            <>
              <ReactPlayer 
                url={media[curr]} 
                playing={isPlaying}
                width={!isLandscape ? '100%' : 'auto'}
                height={!isLandscape ? 'auto' : '100%'}
                playsinline={true}
                onEnded={handleVideoEnd}
                key={curr}
              />
            </>
            : <img src={media[curr]} />
          }
        </div>
      </div>
      
    </div>
  );
}

export default MediaSlider;
